var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit04Primary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74449 2.80094C10.2649 2.28021 11.1089 2.27985 11.6298 2.80015L13.1988 4.36732C13.7199 4.88783 13.7202 5.73226 13.1996 6.25321L6.56102 12.8954C6.37531 13.0812 6.13885 13.208 5.88132 13.2599L2.93117 13.8544C2.71226 13.8985 2.48581 13.83 2.32795 13.6721C2.17009 13.5141 2.1018 13.2876 2.14603 13.0688L2.74153 10.1221C2.79347 9.86512 2.92003 9.62914 3.10538 9.44369L9.74449 2.80094ZM12.2565 5.31066L10.6876 3.74349L4.04845 10.3862L3.65178 12.349L5.61796 11.9528L12.2565 5.31066Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit04Primary);
export default __webpack_public_path__ + "static/media/ic-edit-04-primary.5a77452ce5d8f7662c234393b19e7b6b.svg";
export { ForwardRef as ReactComponent };